export const ALIGN_Y_MAP: Record<
  'top' | 'center' | 'bottom',
  'flex-start' | 'center' | 'flex-end'
> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

export const BORDER_RADIUS_MAP = {
  0: '0',
  1: '0.125rem',
  2: '0.25rem',
} as const;
